import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: '3-5 ore a settimana a cercare esercizi su YouTube',
  good: '10 minuti a settimana aprendo il sistema'
}, {
  bad: 'Sempre gli stessi esercizi base',
  good: '60+ lezioni e progressioni pronte'
}, {
  bad: 'Infortuni per tecnica sbagliata',
  good: 'Biomeccanica corretta e articolazioni protette'
}, {
  bad: 'Nessuna progressione verso coreografie avanzate',
  good: '7 volumi con pianificazione annuale completa'
}, {
  bad: 'Lezioni improvvisate e allieve frustrate',
  good: 'Adattamento al livello di ogni allieva'
}, {
  bad: 'Zero struttura visibile di avanzamento',
  good: 'Sistema diretto al livello successivo'
}];
export function Comparison() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-47">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-10 md:mb-16" data-id="element-49">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal mb-4 md:mb-6" data-id="element-50">
            LA REALTÀ
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-51">
            Quanto costa NON averlo?
          </p>
        </div>

        <div className="bg-ballet-50 rounded-3xl p-5 md:p-10 border border-ballet-100 shadow-sm" data-id="element-52">
          <div className="hidden md:grid grid-cols-2 gap-8 mb-8 pb-4 border-b border-ballet-200" data-id="element-53">
            <h3 className="text-xl font-bold text-gray-500 text-center" data-id="element-54">
              Senza Ballet Pronto™
            </h3>
            <h3 className="text-xl font-bold text-ballet-700 text-center" data-id="element-55">
              Con Ballet Pronto™
            </h3>
          </div>

          <div className="space-y-4 md:space-y-6" data-id="element-56">
            {comparisons.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8 items-center group" data-id="element-57">
                <div className="flex items-start md:justify-end bg-white md:bg-transparent p-4 md:p-2 rounded-xl md:rounded-lg shadow-sm md:shadow-none transition-colors group-hover:bg-red-50/50" data-id="element-58">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-59" />
                  <span className="text-sm md:text-base text-gray-600 md:text-right" data-id="element-60">
                    {item.bad}
                  </span>
                </div>

                <div className="flex items-start bg-ballet-100/50 md:bg-transparent p-4 md:p-2 rounded-xl md:rounded-lg border border-ballet-200 md:border-none transition-colors group-hover:bg-ballet-100/80" data-id="element-61">
                  <CheckCircle2 className="w-5 h-5 text-ballet-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-62" />
                  <span className="text-sm md:text-base text-charcoal font-medium" data-id="element-63">
                    {item.good}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}